import { Modal } from 'react-bootstrap';
import LoadingSpinner from '../LoadingSpinner';

const LoadingModal = ({ show, title, message }) => {

    return (
        <>
            <Modal size='lg' show={show} centered>
                <Modal.Header closeButton={false}>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <LoadingSpinner loadingText={message} />
                </Modal.Body>
            </Modal>
        </>
    )
}

export default LoadingModal